// colors
import { colors } from '../../../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  bottomView: {
    position: 'relative',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    padding: 32,
    zIndex: 2,
  },
  actions: {
    position: 'relative',
    display: 'flex',
    gap: 12,
    alignItems: 'center',
  },
  iconBtn: {
    width: 56,
    height: 56,
    minWidth: 56,
    borderRadius: '50%',
    backgroundColor: colors.white,
    boxShadow:
      '0px 10px 20px 0px rgba(0, 0, 0, 0.04), 0px 2px 6px 0px rgba(0, 0, 0, 0.04), 0px 0px 1px 0px rgba(0, 0, 0, 0.04)',
    '&:hover': {
      backgroundColor: colors.white,
    },
  },
  videoActive: {
    backgroundColor: colors.primary500,
    '& svg path': {
      color: colors.white,
    },
    '&:hover': {
      '& svg path': {
        color: colors.neutral900,
      },
    },
  },
  AudioActive: {
    backgroundColor: colors.primary500,
    '& svg path': {
      color: colors.white,
    },
    '&:hover': {
      '& svg path': {
        color: colors.neutral900,
      },
    },
  },
  shareActive: {
    backgroundColor: colors.primary500,
    border: 'none',
    '& svg path': {
      fill: colors.white,
    },
    '&:hover': {
      border: 'none',
      backgroundColor: colors.primary600,
    },
  },
  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: colors.white,
      border: `2px solid ${colors.neutral200}`,
    },
  },
});
